import { render, staticRenderFns } from "./PrimerMarketing.vue?vue&type=template&id=eda691e2&scoped=true&"
import script from "./PrimerMarketing.vue?vue&type=script&lang=js&"
export * from "./PrimerMarketing.vue?vue&type=script&lang=js&"
import style0 from "./PrimerMarketing.vue?vue&type=style&index=0&id=eda691e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda691e2",
  null
  
)

export default component.exports